import { render, staticRenderFns } from "./AddModifier.vue?vue&type=template&id=30b8dd4c"
import script from "./AddModifier.vue?vue&type=script&lang=js"
export * from "./AddModifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports